import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppearanceAnimation, ButtonLayoutDisplay, ButtonMaker, DialogInitializer, DialogLayoutDisplay, DisappearanceAnimation } from '@costlydeveloper/ngx-awesome-popup';
import { faArrowLeft, faChevronDown, faListRadio, faMoneyBillTransfer, faPrint, faRotateLeft, faTicket, faTimes } from '@fortawesome/pro-light-svg-icons';
import { faCircle, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { faPercent, faTag } from '@fortawesome/pro-regular-svg-icons';
import { AppSettings } from 'src/app/app-settings';
import { DialogPartialRefundConfirmComponent } from 'src/app/components/dialog-partial-refund-confirm/dialog-partial-refund-confirm.component';
import { DialogRefundConfirmComponent } from 'src/app/components/dialog-refund-confirm/dialog-refund-confirm.component';
import { DialogRefundOrderComponent } from 'src/app/components/dialog-refund-order/dialog-refund-order.component';
import { RefundsService } from 'src/app/services/refunds.service';

@Component({
  selector: 'app-refund-detail',
  templateUrl: './refund-detail.component.html',
  styleUrls: ['./refund-detail.component.scss']
})
export class RefundDetailComponent {
  faArrowLeft = faArrowLeft;
  faListRadio = faListRadio;
  faTicket = faTicket;
  faPrint = faPrint;
  faRotateLeft = faRotateLeft;
  faMoneyTransfer = faMoneyBillTransfer;
  faCircle = faCircle;
  faInfoCircle = faInfoCircle;
  faTimes = faTimes;
  faChevronDown = faChevronDown;
  faPercent = faPercent;
  faTag = faTag;

  loadedContent = false;
  discountExpanded = false;

  multiSelectMode: boolean = false;
  multiSelectArray: any = [];

  orderInfo!: any;
  bookingsOrder: any[] = [];
  channelsOptions: any[] = [];
  urlImage = AppSettings.API_EVENTS_ASSETS;

  constructor(private location: Location, private refundsService: RefundsService, private dialog: MatDialog) { }

  ngOnInit() {
    this.refundsService.getChannelOptions().subscribe({
      next: (res) => {
        this.channelsOptions = res.data;
      }
    });
    this.loadData();
  }

  loadData() {
    this.loadedContent = false;
    const url = window.location.href;
    const id = url.split('/')[url.split('/').length - 1];
    this.refundsService.getOrderByIdInvoice(id).subscribe((res: any) => {
      this.orderInfo = res.data;
      this.createEventArray();
    });
  }

  createEventArray() {
    this.bookingsOrder = [];

    this.orderInfo.cart?.cart_lines?.forEach(line => {
      let eventIndex = this.bookingsOrder.findIndex(eventSession => eventSession.event.id == line.event.id && eventSession.session.start_date == line.session.start_date);
      if (eventIndex == -1) {
        let bookings = [];
        line.bookings.forEach(booking => {
          bookings.push({ ticket: line.ticket, booking: booking });
        });
        this.bookingsOrder.push(
          {
            event: line.event,
            session: line.session,
            bookings: bookings
          }
        );

      } else {
        line.bookings.forEach(booking => {
          this.bookingsOrder[eventIndex].bookings.push({ ticket: line.ticket, booking: booking });
        });
      }
    });
    this.loadedContent = true;
  }

  getChannelName(channel: any) {
    let name = '';
    let channelFind = this.channelsOptions.find(value => value.id == channel);
    if (channelFind) {
      name = channelFind.name;
    }
    return name;
  }

  printTicket(type: any) {
    this.refundsService.getPrintUrl(this.orderInfo.id).subscribe((res: any) => {
      window.open(res.data[type], '_blank');
    });
  }


  printSingleTicket(id: any, type: any) {
    this.refundsService.getPrintUrl(this.orderInfo.id).subscribe((res: any) => {
      let uriDownload = `${res.data[type]}?booking_ids[]=${id}`
      window.open(uriDownload, '_blank');
    });
  }

  refundOrder() {
    const dialogRef = this.dialog.open(DialogRefundConfirmComponent, {
      width: '650px',
      panelClass: 'rounded-dialog',
      data: { id: this.orderInfo.id_invoicing, work_time: localStorage.getItem('id_work_time') }
    })

    dialogRef.afterClosed().subscribe(result => {
      this.loadData();
    });
  }

  refundTicket(id: any) {
    const dialogRef = this.dialog.open(DialogPartialRefundConfirmComponent, {
      width: '650px',
      panelClass: 'rounded-dialog',
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.refund([id]);
      }
    });
  }

  refundEvent(event: any) {
    const bookings = event.bookings.map(element => element.booking.id);
    const dialogRef = this.dialog.open(DialogPartialRefundConfirmComponent, {
      width: '650px',
      panelClass: 'rounded-dialog',
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.refund(bookings);
      }
    });
  }

  multiRefund() {
    const dialogRef = this.dialog.open(DialogPartialRefundConfirmComponent, {
      width: '650px',
      panelClass: 'rounded-dialog',
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.refund(this.multiSelectArray);
        this.multiSelectArray = [];

        this.multiSelectMode = false;
      }
    });
  }

  refund(booking_ids?: any) {
    let payload = {};
    if (booking_ids) {
      payload['booking_ids'] = booking_ids;
    }
    this.refundsService.refundOrder(this.orderInfo.id_invoicing, payload, localStorage.getItem('id_work_time')).subscribe((data: any) => {
      this.loadData();
    });
  }

  check(event: any, object: any) {
    if (event) {
      this.multiSelectArray.push(object.booking.id);
    } else {
      this.multiSelectArray = this.multiSelectArray.filter((item: any) => item !== object.booking.id);
    }
  }

  isRefundAvailable(data: any) {
    return true;
  }

  isAllEventRefund(line: any) {
    let allRefund = true;
    line.bookings?.forEach(element => {
      if (element.booking.status.name != 'refunded') {
        allRefund = false;
      }
    });
    return allRefund;
  }

  allowMultiSelect() {
    let allow = true;
    if (this.bookingsOrder.length == 0) {
      allow = false;
    }
    if (this.bookingsOrder.length == 1 && this.bookingsOrder[0].bookings.length == 1) {
      allow = false;
    }
    let refundCount = 0;
    let totalCount = 0;
    this.bookingsOrder.forEach(order => {
      order.bookings.forEach(booking => {
        totalCount++;
        if (booking.status?.name == 'refunded') {
          refundCount++;
        }
      });
    });
    if (refundCount >= totalCount - 1) {
      allow = false;
    }
    return allow;
  }

  goBack() {
    this.location.back();
  }

}
